<script setup lang="ts">
import { provide, ref, onMounted, onBeforeUnmount, computed } from 'vue'
import BaseChart from '@/charts/BaseChart.vue'

const props = defineProps<{
	  successful: number
	  failed: number
}>()

const chartOptions = computed(() => ({
	  tooltip: {
		      trigger: 'item'
		    },
	  series: [
		      {
			            name: 'Transfers',
			            type: 'pie',
			            radius: '70%',
			            center: ['50%', '50%'],
			            data: [
					            { value: props.successful, name: 'Successful' },
					            { value: props.failed, name: 'Failed' }
					          ],
			            emphasis: {
					            itemStyle: {
							              shadowBlur: 10,
							              shadowOffsetX: 0,
							              shadowColor: 'rgba(0, 0, 0, 0.5)'
							            }
					          },
			            color: ['#22c55e', '#ef4444']
			          }
		    ]
}))
</script>

<template>
	  <div class="h-full w-full flex flex-col">
		      <div class="text-center mb-2">
			            <h3 class="font-semibold">Total Transfers</h3>
				          <p class="text-sm text-gray-500">
					          {{ props.successful + props.failed }} total
						        </p>
							    </div>
							        <BaseChart :options="chartOptions" class="flex-1" />
								  </div>
</template>
